import sharedStores from '🔗/stores';
import useNavStore from '@/stores/nav';
import useAppsStore from '@/stores/apps';

// 1. Создаем пустой объект
const stores = {};

// 2. Безопасно копируем дескрипторы (геттеры) из sharedStores, не вызывая их
Object.defineProperties(stores, Object.getOwnPropertyDescriptors(sharedStores));

// 3. Добавляем локальный стор через геттер
Object.defineProperty(stores, 'nav', {
    get() { return useNavStore; },
    enumerable: true // чтобы свойство было видимым
});

Object.defineProperty(stores, 'apps', {
    get() { return useAppsStore; },
    enumerable: true
});


export default stores;